module.exports = __webpack_public_path__ + "img/hzzs-1.cfb48f3c.png";